module.exports = __webpack_public_path__ + "static/media/18.979cb4b9.jpg";